import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export function RoutedThroughLocation({ node }) {
    return (_jsxs(_Fragment, { children: ["Location \u00B7", ' ', node.match === true ? _jsx("strong", { children: node.name }) : 'No match'] }));
}
